module.exports = __webpack_public_path__ + "static/media/knowledge.0deb4dc8.jpeg";